export default __webpack_public_path__ + "images/imagite-stone-0.svg";